import { ReactNode, CSSProperties } from "react";
import { Grid, Container, Box } from "@mui/material";
import { Section } from "../Section";
import { styled } from "@mui/material/styles";
import { Card } from "../Card";
import { Table } from "../Table/Table";
import { TableProps } from "../Table";
import NetworkStatus from "features/common/components/NetworkStatus";

export const StyledSection = styled(Section)`
  overflow: hidden;
`;

type FetchedTableProps = TableProps & {
  isFetchingRows?: boolean;
};

export type CardTableProps = {
  title: string;
  actionsPanel?: ReactNode;
  sticky?: boolean;
  style?: CSSProperties;
  tableProps: FetchedTableProps;
};

export const CardTable = ({
  actionsPanel,
  style,
  title,
  sticky,
  tableProps,
}: CardTableProps) => {
  return (
    <Card
      title={title}
      Component={StyledSection}
      actions={actionsPanel}
      sticky={sticky}
      style={{ width: "100%", ...style }}
    >
      <Grid item xs={12}>
        <Container maxWidth="xl">
          <Grid container spacing={3}>
            <Box sx={{ width: "100%" }}>
              <NetworkStatus
                loading={tableProps.isFetchingRows ?? false}
                errorMessage={""}
              >
                <Table {...tableProps} />
              </NetworkStatus>
            </Box>
          </Grid>
        </Container>
      </Grid>
    </Card>
  );
};
